import { c as _c } from "react/compiler-runtime";
import { twMerge } from 'tailwind-merge';
import { Fmt } from './Fmt';
import { CSSProperties } from 'react';
export const FmtLabel = t0 => {
  const $ = _c(18);
  const {
    value,
    showSign,
    type,
    unit,
    fmt,
    classNames,
    styles
  } = t0;
  const t1 = classNames?.value;
  let t2;
  if ($[0] !== t1) {
    t2 = twMerge("font-extrabold text-[1.2em] font-numbers opacity-60", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = styles?.value;
  let t4;
  if ($[2] !== fmt || $[3] !== showSign || $[4] !== type || $[5] !== value) {
    t4 = Fmt.fmt(value, {
      fmt,
      showSign,
      type
    });
    $[2] = fmt;
    $[3] = showSign;
    $[4] = type;
    $[5] = value;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t5 = <span className={t2} style={t3}>{t4}</span>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== classNames?.unit || $[12] !== styles?.unit || $[13] !== unit) {
    t6 = unit && <span className={twMerge("text-[0.9em] opacity-70", classNames?.unit)} style={styles?.unit}>{unit}</span>;
    $[11] = classNames?.unit;
    $[12] = styles?.unit;
    $[13] = unit;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};